import { Box, styled } from '@mui/material'

export const UsernameContainer = styled(Box)`
  display: flex;
  align-items: center;
`
